<template>
  <div class="spring_page">
    <div class="first_page" v-if="page==1">
        <div class="first_page__back">
            <img src="@/assets/spring/leaves.png">
        </div>
        <div class="first_page__top_img">
            <img src="@/assets/spring/top_flower.png"/>
        </div>
        <div class="first_page__title">
            <img src="@/assets/spring/title.png">
            <p class="first_page__title_txt"><b>축복</b>이 될 <b>말씀</b>을 뽑아보세요!</p>
        </div>
        <div class="first_page__btn" v-on:click="choiceVerse()">
            <img src="@/assets/spring/choice_btn.png">
            <h2 class="first_page__btn_txt">말씀뽑기</h2>
        </div>
        <div class="first_page__bottom_img">
            <img class="grass" src="@/assets/spring/footer_grass.png"/>
            <img class="logo" src="@/assets/spring/logo.png"/>
        </div>

    </div>
    <div class="second_page" v-if="page==2" >
        <div class="second_page__back">
            <img src="@/assets/spring/leaves.png">
        </div>
        <div class="second_page__card">
            <img src="@/assets/spring/back2.png">
            <div class="second_page__load">
                <img src="@/assets/spring/flower.png">
            </div>
            <div class="second_page__txt_area">
                <p class="second_page__txt">성구를<br>뽑는 중 입니다.</p>
            </div>
            <div class="second_page__logo">
                <img src="@/assets/spring/logo2.png">
            </div>
        </div>
        <div class="second_page__top_img">
            <img src="@/assets/spring/top_flower.png"/>
        </div>
    </div>
    <div class="third_page" v-if="page==3">
        <div class="transform_area" :class="scroll?'on':''">
            <div class="capture_area">
                <div class="capture_area__top_img">
                    <img src="@/assets/spring/top_flower.png"/>
                </div>
                <div class="capture_area__card">
                    <img src="@/assets/spring/back2.png">
                    <div class="capture_area__load">
                        <img src="@/assets/spring/flower.png">
                    </div>
                    <div class="capture_area__txt_area">
                        <p class="capture_area__txt">{{print_verse.verse}}</p>
                        <p class="capture_area__verse">{{print_verse.chapter}}</p>
                    </div>
                    <div class="capture_area__logo">
                        <img src="@/assets/spring/logo2.png">
                    </div>
                </div>
                <div class="capture_area__arrow" v-on:click="scrollClick()">
                    <img src="@/assets/spring/arrow.png">
                </div>
            </div>
            <div class="menu_area">
                <div class="menu_area__back">
                    <img src="@/assets/spring/leaves.png">
                </div>
                <div class="menu_area__top_img">
                    <img src="@/assets/spring/top_flower.png"/>
                </div>
                <div class="menu_area__title">
                    <img src="@/assets/spring/title.png">
                </div>
                <ul class="menu_area__list">
                    <li class="menu_area__item" v-on:click="choiceVerse()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">말씀 다시뽑기</p>
                    </li>
                    <li class="menu_area__item" v-on:click="shareClick()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">링크 복사하기</p>
                    </li>
                    <li class="menu_area__item" v-on:click="imgSave()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">이미지 저장하기</p>
                    </li>
                    <li class="menu_area__item" v-on:click="gotoAnother()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">다른 테스트하기</p>
                    </li>
                    <li class="menu_area__item" v-on:click="gotoWs()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">말씀광장 가보기</p>
                    </li>
                    <li class="menu_area__item" v-on:click="scrollClick()">
                        <img src="@/assets/spring/btn.png">
                        <p class="menu_area__item_txt">돌아가기</p>
                    </li>
                </ul>
                <div class="menu_area__bottom_img">
                    <img class="grass" src="@/assets/spring/footer_grass.png"/>
                    <img class="logo" src="@/assets/spring/logo.png"/>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props : ['verse','scroll','page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save'],
    methods: {
        choiceVerse(){
            this.goto_choice();
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        }
    },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/scss/spring.scss';
</style>
